import { faKey } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Col, Row, Space } from 'antd'
import { useContext } from 'react'
import LabeledSwitch from '../../common/LabeledSwitch'
import UsersPageContext from '../UsersPageContext'

const SuperUserSection = () => {
  const { state: { isSuperUser, isFreeUser }, dispatch } = useContext(UsersPageContext)

  return (
    <Card title={<Space><FontAwesomeIcon icon={faKey} />Super User</Space>} bordered={false}>
      <Row>
        <Col span={12}>
          <LabeledSwitch 
            label='Super User — This user can log into all tenants.' 
            value={isSuperUser}
            checked={isSuperUser} 
            onChange={(checked) => dispatch({ type: 'SET_FIELD', fieldName: 'isSuperUser', payload: checked })} 
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <LabeledSwitch 
            label='Free User — This user does not count toward license limits.' 
            value={isFreeUser}
            checked={isFreeUser} 
            onChange={(checked) => dispatch({ type: 'SET_FIELD', fieldName: 'isFreeUser', payload: checked })} 
          />
        </Col>
      </Row>
    </Card>
  )
}

export default SuperUserSection
